import { Box } from "@chakra-ui/react";
import { NodeProps } from "@xyflow/react";
import { GrayScaleContext } from "features/entities/EntityCreatePage/EntityGraph/GrayScaleContext";
import InvestingHandles from "features/entities/EntityCreatePage/EntityGraph/nodes/InvestingHandles";
import { NodeLabel } from "features/entities/EntityCreatePage/EntityGraph/nodes/NodeLabel";
import { type CircleNode as NodeType } from "features/entities/EntityCreatePage/EntityGraph/nodes/types";
import { useContext } from "react";

export const CircleNode = ({ data, id }: NodeProps<NodeType>) => {
  const { isGrayScale } = useContext(GrayScaleContext);
  return (
    <Box
      sx={{
        background: isGrayScale ? "white" : data.backgroundColor,
        color: isGrayScale ? "black" : "white",
        width: "150px",
        height: "150px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        border: isGrayScale ? "2px solid" : "none",
        textAlign: "center",
      }}
    >
      <NodeLabel label={data.label} />
      <InvestingHandles nodeId={id} />
    </Box>
  );
};
